var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8c.075 0 .147.02.215.06.067.041.118.104.151.188l.915 2.275 2.357.215a.41.41 0 01.216.094c.052.048.093.11.12.186a.4.4 0 01-.113.444l-1.785 1.62.536 2.408a.37.37 0 01-.015.247.455.455 0 01-.142.181.402.402 0 01-.206.08.36.36 0 01-.226-.058L12 14.661l-2.022 1.28a.36.36 0 01-.227.057.402.402 0 01-.206-.08.455.455 0 01-.142-.18.37.37 0 01-.015-.248l.536-2.408-1.785-1.62a.407.407 0 01-.114-.444.465.465 0 01.121-.186.41.41 0 01.216-.094l2.357-.215.915-2.275a.366.366 0 01.151-.187C11.853 8.02 11.925 8 12 8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.589 2.508a1 1 0 01.708.437l.406.61a1 1 0 00.708.437L9.535 4H21a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V3.5a1 1 0 01.897-.995L3 2.5h4.465l.124.008zM3.5 18.5h17v-13H9.535a2.5 2.5 0 01-1.99-.986l-.09-.127L7.197 4H3.5v14.5z",
    fill: "currentColor"
  })));
}
SvgSelections.displayName = 'Selections';
export default SvgSelections;